import { createPermission } from '@backstage/plugin-permission-common';

/**
 * Gates visibility of the IMS control panel page. Granted to
 * group:default/infra-aura via the Portal RBAC UI (Admin -> RBAC).
 *
 * This only controls Portal visibility; ims-management-api separately
 * enforces its own JWT allowlist on every /v1 call.
 */
export const imsControlPanelReadPermission = createPermission({
  name: 'ims-control-panel.read',
  attributes: { action: 'read' },
});

/**
 * Gates the write actions (create, edit, promote/demote, delete). Granted
 * separately from read so the panel can be broadly visible while mutations
 * stay restricted. ims-management-api still enforces its own JWT allowlist,
 * so this permission alone never grants API access.
 */
export const imsControlPanelWritePermission = createPermission({
  name: 'ims-control-panel.write',
  attributes: { action: 'update' },
});

export const imsControlPanelPermissions = [
  imsControlPanelReadPermission,
  imsControlPanelWritePermission,
];
